module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities mdl-shadow--2dp"
  }, [_c('table', {
    staticClass: "mdl-data-table mdl-js-data-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.activities), function(activity) {
    return _c("activity-row", {
      key: activity.id,
      tag: "tr",
      attrs: {
        "activity": activity
      }
    })
  }), _vm._v(" "), (_vm.no_more) ? _c('tr', {
    staticClass: "nomore"
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("End of results!")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "100"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "time-col"
  }, [_vm._v("Time")]), _vm._v(" "), _c('th', {
    staticClass: "email-col"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticClass: "org-col"
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('th', {
    staticClass: "action-col"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "link-col"
  }, [_vm._v("Link")]), _vm._v(" "), _c('th', {
    staticClass: "details-col"
  }, [_vm._v("Details")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408792bb","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/activity_table.vue
// module id = 17
// module chunks = 0 1